import { S } from "@/lib/sessionsApi";

const ICE = { iceServers: [{ urls: ["stun:stun.l.google.com:19302", "stun:stun1.l.google.com:19302"] }] };

export class Mesh {
  constructor(sessionId, me, localStream, onPeers) {
    this.sid = sessionId; this.me = me; this.local = localStream; this.onPeers = onPeers;
    this.peers = new Map(); this.names = new Map(); this.alive = true;
  }

  start() { this.tick(); this.timer = setInterval(() => this.tick(), 1200); }

  async tick() {
    if (!this.alive) return;
    try {
      const { signals, participants } = await S.signals(this.sid);
      const ids = new Set(participants.filter((p) => p.user_id !== this.me).map((p) => p.user_id));
      participants.forEach((p) => this.names.set(p.user_id, p.name));
      ids.forEach((id) => { if (!this.peers.has(id)) this.connect(id, this.me < id); });
      [...this.peers.keys()].forEach((id) => { if (!ids.has(id)) this.drop(id); });
      for (const s of signals) await this.handle(s);
    } catch (e) { /* transient */ }
  }

  connect(id, initiator) {
    const pc = new RTCPeerConnection(ICE);
    const entry = { pc, stream: new MediaStream(), pendingIce: [], name: this.names.get(id) };
    this.peers.set(id, entry);
    this.local?.getTracks().forEach((t) => pc.addTrack(t, this.local));
    pc.ontrack = (e) => { e.streams[0]?.getTracks().forEach((t) => entry.stream.addTrack(t)); this.emit(); };
    pc.onicecandidate = (e) => { if (e.candidate) S.signal(this.sid, id, "ice", e.candidate.toJSON()); };
    pc.onconnectionstatechange = () => { entry.state = pc.connectionState; this.emit(); if (pc.connectionState === "failed") this.drop(id); };
    if (initiator) pc.createOffer().then(async (o) => { await pc.setLocalDescription(o); S.signal(this.sid, id, "offer", o); });
    this.emit();
  }

  async handle(s) {
    let entry = this.peers.get(s.from);
    if (!entry) { this.connect(s.from, false); entry = this.peers.get(s.from); }
    const { pc } = entry;
    try {
      if (s.type === "offer") {
        await pc.setRemoteDescription(s.payload);
        const a = await pc.createAnswer(); await pc.setLocalDescription(a);
        S.signal(this.sid, s.from, "answer", a);
        for (const c of entry.pendingIce) await pc.addIceCandidate(c);
        entry.pendingIce = [];
      } else if (s.type === "answer") {
        if (pc.signalingState === "have-local-offer") await pc.setRemoteDescription(s.payload);
        for (const c of entry.pendingIce) await pc.addIceCandidate(c);
        entry.pendingIce = [];
      } else if (s.type === "ice") {
        if (pc.remoteDescription) await pc.addIceCandidate(s.payload); else entry.pendingIce.push(s.payload);
      }
    } catch (e) { /* ignore glare */ }
  }

  replaceVideoTrack(track) {
    this.peers.forEach(({ pc }) => { const sender = pc.getSenders().find((x) => x.track?.kind === "video"); if (sender) sender.replaceTrack(track); });
  }

  drop(id) { const e = this.peers.get(id); if (e) { e.pc.close(); this.peers.delete(id); this.emit(); } }
  emit() { this.onPeers([...this.peers.entries()].map(([id, e]) => ({ id, name: e.name || this.names.get(id) || "Teammate", stream: e.stream, state: e.state || "connecting" }))); }
  stop() { this.alive = false; clearInterval(this.timer); this.peers.forEach((e) => e.pc.close()); this.peers.clear(); }
}
